export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[420px] md:min-h-[600px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20with%20warm%20peach%20and%20coral%20gradients%2C%20soft%20flowing%20curves%20suggesting%20film%20reels%2C%20elegant%20light%20leaks%20and%20lens%20flares%2C%20modern%20streaming%20platform%20atmosphere%2C%20artistic%20minimal%20design%20with%20rich%20texture&width=1600&height=900&seq=hero-main-bg-01&orientation=landscape"
          alt="桃子视频 - 免费高清影视在线观影平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 w-full max-w-[1280px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs md:text-sm text-primary-200 font-medium whitespace-nowrap">每日更新 · 高清流畅</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-white leading-tight mb-3">
              桃子视频
              <span className="block text-lg md:text-xl lg:text-2xl font-body font-light text-white/80 mt-2">
                红桃黑桃桃花红杏影视大全
              </span>
            </h1>

            <p className="text-sm md:text-base text-white/70 leading-relaxed mb-6 max-w-xl lg:max-w-none">
              桃子视频是一个覆盖红桃视频、黑桃视频、桃花视频、红杏视频、糖心视频、豆花视频、粉桃视频、白桃视频等十余个情感色彩频道的综合影视平台。
              提供免费高清电影电视剧在线播放服务，每日同步更新热门资源，多线路智能切换确保观影全程不卡顿。
              无论你喜欢温情治愈、悬疑烧脑还是轻松搞笑，都能在这里找到属于你的观影频道。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading text-accent-400 whitespace-nowrap">10万+</div>
                <div className="text-xs text-white/50 whitespace-nowrap">影视资源</div>
              </div>
              <div className="w-px h-8 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading text-accent-400 whitespace-nowrap">13个</div>
                <div className="text-xs text-white/50 whitespace-nowrap">主题频道</div>
              </div>
              <div className="w-px h-8 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading text-accent-400 whitespace-nowrap">7×24h</div>
                <div className="text-xs text-white/50 whitespace-nowrap">持续更新</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-8 py-3 bg-white/10 hover:bg-white/20 text-white border border-white/30 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] md:w-[360px] md:h-[480px] rounded-2xl overflow-hidden border-2 border-white/20 shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20Chinese%20film%20poster%20design%20with%20a%20mysterious%20figure%20in%20traditional%20style%20clothing%20standing%20in%20dramatic%20lighting%2C%20warm%20peach%20and%20golden%20tones%2C%20cinematic%20composition%2C%20artistic%20movie%20poster%20with%20Chinese%20calligraphy%20elements&width=720&height=960&seq=hero-poster-02&orientation=portrait"
                alt="桃子视频主题主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="text-white/90 text-xs mb-1 font-medium">本周热播</div>
                <div className="text-white font-heading text-lg md:text-xl">繁花深处</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}